
/** Seconds for working with delta */
export const SECONDS = 1000;


/** Width of the canvas (CHANGE THIS IN INDEX.HTML TOO) */
export const CANVAS_WIDTH = 700;
/** Height of the canvas (CHANGE THIS IN INDEX.HTML TOO) */
export const CANVAS_HEIGHT = 700;
